<template>
  <div class="charging-operation">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
    >
      <div class="sub-title">基本信息</div>
      <el-form-item label="仓库" prop="warehouseId">
        <el-select
          class="white"
          v-model="ruleForm.warehouseId"
          placeholder="请选择"
          @change="changeWarehouse"
        >
          <el-option
            v-for="item in warehouseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目名称" prop="projectId">
        <el-select
          class="white"
          v-model="ruleForm.projectId"
          placeholder="请选择"
          @change="changeProject"
        >
          <el-option
            v-for="item in projectListByWarehouseAndAuth"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日期" prop="billDate">
        <el-date-picker
          v-model="ruleForm.billDate"
          type="date"
          placeholder="请选择"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="快递公司" prop="expressId">
        <el-select
          class="white"
          v-model="ruleForm.expressId"
          placeholder="请选择"
        >
          <el-option
            v-for="item in expressList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <div class="sub-title">索赔内容</div>
      <el-form-item label="订单号" prop="orderCode">
        <el-input
          v-model="ruleForm.orderCode"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="快递单号" prop="expressCode">
        <el-input
          v-model="ruleForm.expressCode"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="问题描述" prop="questionContent">
        <el-input
          type="textarea"
          class="remarks"
          v-model="ruleForm.questionContent"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="责任归属" prop="responsibleParty">
        <el-select
          class="white"
          v-model="ruleForm.responsibleParty"
          placeholder="请选择"
          @change="changeResponsibleParty"
        >
          <el-option
            v-for="item in responsiblePartyList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="问题分类" prop="logisticsProblemsType">
        <el-select
          class="white"
          v-model="ruleForm.logisticsProblemsType"
          placeholder="请选择"
        >
          <el-option
            v-for="item in logisticsProblemTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产品名称" prop="productName">
        <el-input
          v-model="ruleForm.productName"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="数量" prop="quantity">
        <el-input
          class="input-div"
          v-model="ruleForm.quantity"
          placeholder="请输入"
          @input="inputNums(ruleForm.quantity)"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="处理方案" prop="dealMethod">
        <el-select
          class="white"
          v-model="ruleForm.dealMethod"
          placeholder="请选择"
        >
          <el-option
            v-for="item in dealMethodList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申请金额" prop="involvedAmount">
        <el-input
          v-model="ruleForm.involvedAmount"
          placeholder="请输入"
          @input="inputAmount(ruleForm.involvedAmount, 'involvedAmount')"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remarks">
        <el-input
          type="textarea"
          class="white remarks"
          v-model="ruleForm.remarks"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="上传照片" prop="images" class="images">
        <el-upload
          ref="upload"
          action="#"
          :class="ruleForm.images.length < 3 ?'':'none'"
          list-type="picture-card"
          :limit="3"
          :on-exceed="handleLimit"
          :on-remove="onRemove"
          :before-upload="beforeUpload"
          :auto-upload="true"
          :file-list="fileList"
        >
          <el-button
            v-loading="loading"
            element-loading-text="上传中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            slot="trigger"
            size="small"
            type="primary"
          >
            <i class="el-icon-plus add"></i>
          </el-button>
          <div
            slot="tip"
            class="el-upload__tip"
          >最多上传3张，支持jpg、jpeg、png格式</div>
        </el-upload>
      </el-form-item>
      <div class="footer">
        <el-button @click="cancel">清空</el-button>
        <el-button
          class="btn-blue"
          @click="submitForm('ruleForm')"
          >保存</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import Claim from "models/claim"; 
import expressMixins from "@/common/mixins/express.js"
import claimMixins from "@/common/mixins/claim.js"
import projectMixins from "@/common/mixins/project.js"
import warehouseMixins from "@/common/mixins/warehouse.js"
import ImgUploader from "common/js/img-upload.js";
const imgUploader = new ImgUploader();
import { formatTimeToDate, getPositiveInteger, getDecimal } from "common/js/util";
export default {
  mixins: [expressMixins, warehouseMixins, claimMixins, projectMixins],
  data() {
    return {
      fileList: [],
      loading: false,
      ruleForm: {
        warehouseId: "",
        billDate: formatTimeToDate(new Date()),
        customerId: "",
        projectId: "",
        expressId: "",
        // 订单号
        orderCode: "",
        // 快递单号
        expressCode: "",
        // 问题描述
        questionContent: "",
        // 责任归属
        responsibleParty: "",
        // 问题分类
        logisticsProblemsType: "",
        // 产品名称
        productName: "",
        // 数量
        quantity: "",
        // 处理方案
        dealMethod: "",
        // 申请金额
        involvedAmount: "",
        remarks: "",
        images: [],
      },
      rules: {
        warehouseId: [
          {
            required: true,
            message: "请选择仓库",
            trigger: "change",
          },
        ],
        billDate: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        expressId: [
          {
            required: true,
            message: "请选择快递公司",
            trigger: "change",
          },
        ],
        customerId: [
          {
            required: true,
            message: "请选择货主",
            trigger: "change",
          },
        ],
        projectId: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change",
          },
        ],
        orderCode: [
          {
            required: true,
            message: "请输入订单号",
            trigger: "blur",
          },
        ],
        expressCode: [
          {
            required: true,
            message: "请输入快递单号",
            trigger: "blur",
          },
        ],
        questionContent: [
          {
            required: true,
            message: "请输入问题描述",
            trigger: "blur",
          },
        ],
        responsibleParty: [
          {
            required: true,
            message: "请选择责任归属",
            trigger: "blur",
          },
        ],
        logisticsProblemsType: [
          {
            required: true,
            message: "请选择问题分类",
            trigger: "blur",
          },
        ],
        productName: [
          {
            required: true,
            message: "请输入产品名称",
            trigger: "blur",
          },
        ],
        quantity: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
        dealMethod: [
          {
            required: true,
            message: "请选择处理方案",
            trigger: "blur",
          },
        ],
      },
    };
  },

  async created() {
    this.initExpressList()
    await this.initAsyncWarehouse()
    this.ruleForm.warehouseId = this.warehouseList[0].id;
    this.updateProjectByWarehouseId()
  },

  methods: {
    changeWarehouse() {
      this.updateProjectByWarehouseId()
    },

    changeProject() {
      let obj = this.projectListByWarehouseAndAuth.find(item => { return item.id === this.ruleForm.projectId })
      this.ruleForm.customerId = obj.customerId;
    },

    /** 
     * @desc 根据仓库更新项目，默认选择第一个项目
    */
    async updateProjectByWarehouseId() {
      await this.initProjectListByWarehouseCopy(this.ruleForm.warehouseId)
      this.ruleForm.projectId = this.projectListByWarehouseAndAuth.length? this.projectListByWarehouseAndAuth[0].id:'';
      this.ruleForm.customerId = this.projectListByWarehouseAndAuth.length? this.projectListByWarehouseAndAuth[0].customerId:'';
    },

    changeResponsibleParty() {
      this.initProblemTypeList()
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {}
          data = this.ruleForm
          Claim.postAddClaimRegister(data).then(res => {
            if (res.success) {
              this.$message.success('保存成功')
              this.cancel()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      })
    },
    
    cancel() {
      this.fileList = []
      this.$refs['ruleForm'].resetFields();
    },

    /** 
     * @desc 限制数量为正整数
    */
    inputNums(val) {
      this.ruleForm.quantity = Number(getPositiveInteger(val));
    },
    
    /** 
     * @desc 限制金额为2位小数
    */
    inputAmount(val, type) {
      this.ruleForm[type] = Number(getDecimal(val))
    },

    
    /** 
     * @desc 图片数量大于3
    */
    handleLimit() {
      this.$message({
        message: "图片数量最多3张",
        type: "warning",
      });
    },
    
    /** 
     * @desc 删除图片
    */
    onRemove(file, fileList) {
      this.fileList = fileList;
      this.ruleForm.images = [];
      this.fileList.map(value => {
        this.ruleForm.images.push(value.url);
      });
    },

    /** 
     * @desc 上传图片进行判断图片
    */
    beforeUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt1M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
        return false;
      } else {
        this.loading = true;
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then((res) => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              this.fileList.push(obj);
              this.loading = false;
              this.ruleForm.images = [];
              this.fileList.map(value => {
                this.ruleForm.images.push(value.url);
              });
            } else {
              this.loading = false;
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.loading = false;
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
      }
    },
  },
};
</script>

<style lang='scss'>
@import "@/assets/style/layout/production/charging-operation.scss";
</style>
